export default {

  init() {

    $('[data-js="collapse"]').on('click', function(e) {
      e.preventDefault();

      let $toggle = $(this);
      let $pane = $('#'+$toggle.attr('aria-controls'));

      if(!$pane.length) {
        return;
      }

      if($pane.hasClass('is-active')) {
      	$toggle.removeClass('is-less').addClass('is-more').text('More');
      	$pane.removeClass('is-active');

      } else {
      	$toggle.removeClass('is-more').addClass('is-less').text('Less');
      	$pane.addClass('is-active');
      }

    });
  }

};
